module.exports = __webpack_public_path__ + "static/img/default.b748f239.jpg";